module.exports = __webpack_public_path__ + "assets/images/announcement-proximity-open-closed.png";